import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OauthService, UserService } from '@terradotta/commons';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FullStory, init as initFullStory } from '@fullstory/browser';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  @Input() primaryColor: string;
  @Input() loginRegistrationOptions: any;
  @Input() rcValue:number;
  @Input() programId: number;
  @Input() i18nFields: any;
  tdLoginForm: FormGroup;
  forgottenPassword: FormGroup;
  hidePassWord: boolean = true;
  showForgotPassword: boolean = false;
  loadingSpinner: boolean = false;
  passwordErrorMsg: boolean = false;
  loginResponse: any;
  
  @Output() activeAppCycleResults: EventEmitter<any> = new EventEmitter<any>();
  @Output() formMode: EventEmitter<any> = new EventEmitter<any>();
  @Output() redirectURL: EventEmitter<any> = new EventEmitter<any>();
  @Output() applicantUserId: EventEmitter<any> = new EventEmitter<any>();
  @Output() tdPasswordResetForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() tempPW: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private _oauthService: OauthService,
    private snackbar: MatSnackBar,
    private _userService: UserService,
    private _sessionService: SessionService
  ) { 
    this.tdLoginForm = this.createLoginForm();
    this.forgottenPassword = this.createForgotPasswordForm();
    //FullStory init
    initFullStory({
      orgId: 'o-1V47MT-na1'
     });
  }

  ngOnInit() {
    var storedValue: string = localStorage.getItem('td_user_name');
    if(storedValue){
      this.tdLoginForm.patchValue({
        tdUsername: storedValue,
        tdRememberUsername:true
      })
    }
  }
  createLoginForm(){
    return this.fb.group({
      tdUsername: ['', Validators.required],
      tdPassword:['', Validators.required],    
      tdRememberUsername:[false]  
    });
  }
  createForgotPasswordForm(){
    return this.fb.group({
      tdEmailUser:['', [Validators.required, Validators.email]]
    });
  }
  backToLogin(){
    this.showForgotPassword = false
    this.formMode.emit('userLogin')
  }
  userForgotPassword(){
    this.showForgotPassword = !this.showForgotPassword;
    if(this.showForgotPassword){
      this.formMode.emit('pwReset')
    } else {
      this.formMode.emit('newPassword')
    }
  }
  submitForgotPassword(username){
    let reset = {
      username: username
    }
    this._userService.userPasswordReset(reset).subscribe(resp => {
      this.userForgotPassword();
      this.snackbar.open('If the email exists in the system you will receive an email shortly to reset your password','Dismiss',{
        duration: 4000
      });
    },err => {
      this.snackbar.open('There was a problem submitting your request. Please try again.','Dismiss',{
        duration: 4000
      });
    })
  }
  setUsernameLocal(value){
    if(value === true){
      localStorage.setItem('td_user_name',this.tdLoginForm.get('tdUsername').value);
    } else {
      localStorage.removeItem('td_user_name');
    }
  }
  userLogin(username,password){
    this.loadingSpinner = true;
    //
    if(this.rcValue > 0){
      var RC = this.rcValue
    }
    let tdUserInfo = {
      userName: username,
      userPassword: password,
      RC
      
    }   
    this._oauthService.userLogin(tdUserInfo).subscribe(async res => {//
      // create new session after login successfully.
      try {
        const session: any = await this._sessionService.create();
        if(session && session.session_id) {
          localStorage.setItem('tds-session', session.session_id);
          await this._sessionService.update(session.session_id, { user_name: tdUserInfo.userName }).toPromise();
          const sessionData = await this._sessionService.get(session.session_id);
          if(sessionData && sessionData.session_data) {
            this._sessionService.updateCache(sessionData);
            if(localStorage.getItem('tds-session-renewing') == 'true') {
              localStorage.setItem('tds-session-renewed', 'true');
              localStorage.removeItem('tds-session-renewing');
            }
          }
        }
      } catch(e) {
        this.snackbar.open('There was an error while trying to create the session.', 'Dismiss', { duration: 5000 });
      }
      this.loginResponse = res;
      this._oauthService.getToken(true).then((tokenStr: string) => {
        if(tokenStr) {
          //FullStory integration
          const token = Utils.parseJwt(tokenStr);
          FullStory('setIdentity', {
            uid: token.aud +'_'+ token.sub,
            properties: {
              displayName: token.metadata?.userFullName,
              username: token.metadata?.userName,
              email: token.metadata?.userEmail,
              userid: token.sub,
              accountinstance: token.aud,//account_id
              //user_id: token.sub,
              //product_name: 'SA'
            }
          });

          if(this.loginResponse.passwordReset){
            this.redirectURL.emit(this.loginResponse.returnURL)
            this.applicantUserId.emit(this.loginResponse.userId)
            this.tempPW.emit(password)
            this.tdPasswordResetForm.emit(this.loginResponse)
          } else{
            this.loginRedirect(); 
          } 
        }
      })
    },err => {
      var storedValue: string = localStorage.getItem('td_user_name');
      if(storedValue){
        this.tdLoginForm.patchValue({
          tdPassword:''
        })
      } else {
        this.tdLoginForm.patchValue({
          tdPassword:'',
          tdUsername:'',
          tdRememberUsername:false
        })
      }
      if(err.status === 403){
        // this.snackbar.open(err.error,'Dismiss',{
        //   duration: 6000
        // });
        var errMsg = err.error;
        this.snackbar.openFromComponent(acctLockedComponent, {
          data: errMsg,
          // duration:4500
        });
      }else {
        let msg: string = 'There was an error while trying to login. Check your username and password and try again. ';      
        this.snackbar.open(msg,'Dismiss',{
          duration: 4500
        });
      }
      
      this.passwordErrorMsg = true;
      this.loadingSpinner = false;
   }
   );
  }
  loginRedirect(){
    if(this.loginResponse.returnURL !== ''){
      if(this.loginResponse.returnURL.includes('http')){
        window.location.href = this.loginResponse.returnURL
      } else {
        window.location.href = window.location.origin + '/' + this.loginResponse.returnURL        
      }
    } else {      
      window.location.href = window.location.origin + '/index.cfm?FuseAction=Portal.Home';
    }
  }
}


import {Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material/snack-bar';
import { SessionService } from '@terradotta/commons';
import { Utils } from 'projects/management-tool/src/app/Utils';

@Component({
  selector: 'error-403-msg',
  template: '<div class="mat-simple-snackbar"><span class="td-err-snackbar" [innerHTML]="data  | safe: \'html\'"></span><div class="mat-simple-snackbar-action"><button (click)="dismissSnackBar();" class="mat-focus-indicator mat-button mat-button-base" mat-button=""><span class="mat-button-wrapper">Dismiss</span></button></div></div>',
  // styles: 
})


export class acctLockedComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackbar: MatSnackBar) { }
  
  dismissSnackBar(){
  this.snackbar.dismiss()
}
}